import { change } from 'redux-form';

import { INFERENTIAL_STATISTICS as FORM } from '../../names';

export const setSampleMeanDiff = sampleMean =>
  change(FORM, 'pairedT.sampleMeanDiff', sampleMean);

export const setStandardDeviationDiff = standardDeviation =>
  change(FORM, 'pairedT.standardDeviationDiff', standardDeviation);

export const setSampleSize = sampleSize =>
  change(FORM, 'pairedT.sampleSize', sampleSize);

export const setNumericalRowDataSet = sampleSize =>
  change(FORM, 'pairedT.numericalRowDataSet', sampleSize);

export const setSampleMeanFirst = sampleMean =>
  change(FORM, 'pairedT.sampleMeanFirst', sampleMean);

export const setStandardDeviationFirst = standardDeviation =>
  change(FORM, 'pairedT.standardDeviationFirst', standardDeviation);

export const setSampleSizeFirst = sampleSize =>
  change(FORM, 'pairedT.sampleSizeFirst', sampleSize);

export const setSampleMeanSecond = sampleMean =>
  change(FORM, 'pairedT.sampleMeanSecond', sampleMean);

export const setStandardDeviationSecond = standardDeviation =>
  change(FORM, 'pairedT.standardDeviationSecond', standardDeviation);

export const setSampleSizeSecond = sampleSize =>
  change(FORM, 'pairedT.sampleSizeSecond', sampleSize);
